<template>
    <div class="containContent">
        <div class="tit xy-between">
            <div class="sheetTextjf">
                <div class="spare"></div>
                <div class="text font-size16">答题卡</div>
            </div>
            <div class="resetBtn font-size14 c-72777F xy-center">
                <i class="el-icon-delete"></i>
                <span class="cursor" @click="resetMake"> 重做</span>
            </div>
        </div>
        <div class="showMakeStatu ">
            <div class="sparBox jf ">
                <div class="err jf">
                    <div class="btnDote"></div>
                    <div>错误</div>
                </div>
                <div class="right jf statu">
                    <div class="btnDote"></div>
                    <div>正确</div>

                </div>
                <div class="notMake jf statu">
                    <div class="btnDote"></div>
                    <div>未做</div>
                </div>
            </div>
        </div>
        <!-- 题型 -->
        <div class="topicType">

            <div class="mt-5">
                <div class="TopicBox">
                    <div v-for="(item,i) in allTopic" :key="i"
                        :class="{'active': currentOrder === i+1,'errStyle': item.status && item.IsError,'rightStyle': item.status && !item.IsError}"
                        class="topicItem xy-center c-868EA1 font-size16" @click="selectOrder((i+1),item)">
                        <div>{{i+1}}</div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import {
    GetMedicalQueationDetailByClassId,
    DeleteErrSubjectLog,
    DeleteErrSubjectLogArray
} from "@/api/course"
export default {
    props: {
        topicList: {
            type: Array,
            default: () => []
        },
        serialNumber: {
            type: Number,
            default: 0
        },
        errList: {
            type: Array,
            default: () => []
        }
    },
    components: {

    },
    data() {
        return {
            currentOrder: ""
        }
    },
    computed: {
        allTopic: {
            get() {
                return this.topicList
            },
            set(newVal) {
                this.topicList = newVal
            }
        },
        errtopicList: {
            get() {
                return this.errList
            },
            set(newVal) {
                this.errList = newVal
            }

        }
    },
    watch: {
        "errtopicList.length": {
            handler(newVal) {
                this.allTopic.forEach((v, i) => {
                    this.errtopicList.forEach((c, i2) => {
                        if (v.SubjectId === c.id) {
                            v.IsError = c.IsError
                            v.status = c.status
                        }
                    })
                })
            }
        },
        "topicList.length"(val) {
            // this.sortTopic()
        },
        serialNumber(val) {
            this.currentOrder = val
        }
    },
    created() {
    },
    mounted() {
        if (this.serialNumber) {
            this.currentOrder = this.serialNumber
        } else {
            this.currentOrder = 1
        }
    },
    updated() {},
    methods: {
        resetMake() {
            this.$confirm("重做后做题记录和错题记录将重新更新，是否要重做？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            }).then(() => {
                this.confrimRemake()
            }).catch(() => {

            });
        },
        async confrimRemake() {
            let deleteArray = []
            this.allTopic.forEach((v, i) => {
                deleteArray.push(v.SubjectId)
            })
            let str = deleteArray.join(",")
            try {
                const {
                    data
                } = await DeleteErrSubjectLogArray({
                    array: JSON.stringify({ arraymodel: str })
                })
                this.allTopic.forEach((v, i) => {
                    v.status = null
                    v.IsError = null
                    if (i === 0) {
                        this.selectOrder(1, v)
                    }
                })
            } catch (error) {
                console.log(error);
            }
            this.$emit("resetMake")
        },
        findFristNotMake() {

        },
        async GetMedicalQueationDetailByClassId() {
            try {
                const {
                    data
                } = await GetMedicalQueationDetailByClassId({
                    chapterId: this.info.info.id,
                    pageno: 1,
                    pagesize: 99999
                });
                this.allTopic = data.data
                this.allTopic.forEach((v, i) => {
                    v.order = parseInt(i) + 1
                })
            } catch (error) {
                console.log(error);
            }
        },
        selectOrder(val, item) {
            this.currentOrder = val
            this.$emit("jumoTopic", val, item)
        }
    }
}

</script>

<style scoped lang="less">
    .containContent {
        .tit {
             padding: 30px 30px 0 30px;
           box-sizing: border-box;
            .sheetText {
                .spare {
                    width: 4px;
                    height: 18px;
                    background: #256CF4;
                }
            }

            .resetBtn {
                width: 60px;
                height: 30px;
                background: #F9F9FA;
                border-radius: 8px;
                border: 1px solid #256CF4;
                color: #256CF4;
            }
        }

        .showMakeStatu {
             padding-left: 30px;
            box-sizing: border-box;
            margin-top: 20px;
            height: 50px;
            display: flex;
            align-items: center;
            border-top: 1px solid #E5E8EC;
            border-bottom: 1px solid #E5E8EC;
            .sparBox {
                 font-size: 14px;
                  .statu{
                    margin-left: 15px;
                }
            }

            .btnDote {
                 width: 15px;
                height: 15px;
                border-radius: 2px;
                margin-right: 4px;
            }

            .err {
                .btnDote {
                    background: #F33737;
                }
            }

            .right {
                .btnDote {
                    background: #00B37C;
                }
            }

            .notMake {
                .btnDote {
                    background: #FFFFFF;
                    border: 1px solid #E5E8EC;
                }
            }
        }

        .topicType {
              padding: 0px 30px 30px 30px;
           box-sizing: border-box;
            height: 640px;
            overflow: auto;

            .TopicBox {
                float: left;
                .topicItem {
                    float: left;
                    width: 30px;
                    height: 30px;
                    background: #FFFFFF;
                    border-radius: 8px;
                    border: 1px solid #E5E8EC;
                    margin-right: 15px;
                    margin-top: 20px;
                    cursor: pointer;
                }

                .active {
                    background-color: #256CF4;
                    color: white;
                }

                .errStyle {
                    background-color: #F7593B;
                    color: white;
                }

                .rightStyle {
                    background-color: #00B37C;
                    color: white;
                }

            }

            &::-webkit-scrollbar {
                width: 6px;
            }

            &::-webkit-scrollbar-track {
                border-radius: 6px;
            }

            &::-webkit-scrollbar-thumb {
                border-radius: 6px;
                background: #BAC0CA;
            }
        }
    }

</style>
